<template>
  <transition name="slide-up">
    <div v-if="showPrompt" class="install-prompt">
      <div class="install-prompt-content">
        <div class="install-prompt-text">
          <div class="install-prompt-icon">📱</div>
          <div class="install-prompt-message">
            <strong>Установите приложение</strong>
            <span>Добавьте на главный экран для быстрого доступа. Теперь без VPN</span>
          </div>
        </div>
        <div class="install-prompt-actions">
          <button @click="dismiss" class="btn-dismiss">
            Позже
          </button>
          <button @click="install" class="btn-install">
            Установить
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'InstallPrompt',
  data() {
    return {
      deferredPrompt: null,
      showPrompt: false
    }
  },
  mounted() {
    // Проверяем, отклонял ли пользователь ранее
    const dismissed = localStorage.getItem('installPromptDismissed')
    const dismissedDate = dismissed ? parseInt(dismissed) : 0
    const daysSinceDismissed = (Date.now() - dismissedDate) / (1000 * 60 * 60 * 24)
    
    // Если прошло менее 7 дней с момента отклонения, не показываем
    if (daysSinceDismissed < 7) {
      return
    }

    // Слушаем событие beforeinstallprompt
    window.addEventListener('beforeinstallprompt', this.handleBeforeInstallPrompt)
    
    // Проверяем, установлено ли приложение уже
    window.addEventListener('appinstalled', this.handleAppInstalled)
  },
  beforeDestroy() {
    window.removeEventListener('beforeinstallprompt', this.handleBeforeInstallPrompt)
    window.removeEventListener('appinstalled', this.handleAppInstalled)
  },
  methods: {
    handleBeforeInstallPrompt(e) {
      // Предотвращаем стандартное поведение браузера
      e.preventDefault()
      // Сохраняем событие для последующего использования
      this.deferredPrompt = e
      // Показываем промпт с небольшой задержкой
      setTimeout(() => {
        this.showPrompt = true
      }, 3000)
    },
    handleAppInstalled() {
      // Приложение установлено, скрываем промпт
      this.showPrompt = false
      this.deferredPrompt = null
      localStorage.setItem('appInstalled', 'true')
      localStorage.removeItem('installPromptDismissed')
      localStorage.removeItem('showInstallInMenu')
    },
    async install() {
      if (!this.deferredPrompt) {
        return
      }
      
      // Показываем нативный диалог установки
      this.deferredPrompt.prompt()
      
      // Ждем выбора пользователя
      const { outcome } = await this.deferredPrompt.userChoice
      
      if (outcome === 'accepted') {
        console.log('Пользователь принял установку')
      } else {
        console.log('Пользователь отклонил установку')
      }
      
      // Сбрасываем deferredPrompt
      this.deferredPrompt = null
      this.showPrompt = false
    },
    dismiss() {
      this.showPrompt = false
      // Сохраняем время отклонения и флаг для показа в меню
      localStorage.setItem('installPromptDismissed', Date.now().toString())
      localStorage.setItem('showInstallInMenu', 'true')
      // Отправляем событие для обновления меню
      window.dispatchEvent(new CustomEvent('installPromptDismissed'))
    }
  }
}
</script>

<style scoped>
.install-prompt {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.15);
  padding: 0;
}

.install-prompt-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  max-width: 100%;
  margin: 0 auto;
}

.install-prompt-text {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  min-width: 0;
}

.install-prompt-icon {
  font-size: 32px;
  flex-shrink: 0;
  animation: bounce 1s ease infinite;
}

@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
}

.install-prompt-message {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.install-prompt-message strong {
  color: #ffffff;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0.3px;
}

.install-prompt-message span {
  color: rgba(255, 255, 255, 0.85);
  font-size: 13px;
}

.install-prompt-actions {
  display: flex;
  gap: 10px;
  flex-shrink: 0;
}

.btn-dismiss,
.btn-install {
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  outline: none;
}

.btn-dismiss {
  background: rgba(255, 255, 255, 0.15);
  color: #ffffff;
}

.btn-dismiss:hover {
  background: rgba(255, 255, 255, 0.25);
  transform: translateY(-1px);
}

.btn-install {
  background: #ffffff;
  color: #667eea;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.btn-install:hover {
  background: #f8f9ff;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
}

.btn-install:active {
  transform: translateY(0);
}

/* Анимация появления */
.slide-up-enter-active,
.slide-up-leave-active {
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.slide-up-enter-from {
  transform: translateY(100%);
  opacity: 0;
}

.slide-up-leave-to {
  transform: translateY(100%);
  opacity: 0;
}

/* Dark theme */
body.dark-mode .install-prompt {
  background: linear-gradient(135deg, #818cf8 0%, #6366f1 100%);
}

/* Адаптивность для мобильных устройств */
@media (max-width: 576px) {
  .install-prompt-content {
    padding: 12px 16px;
    flex-direction: column;
    gap: 12px;
    align-items: stretch;
  }
  
  .install-prompt-text {
    gap: 10px;
  }
  
  .install-prompt-icon {
    font-size: 28px;
  }
  
  .install-prompt-message strong {
    font-size: 14px;
  }
  
  .install-prompt-message span {
    font-size: 12px;
  }
  
  .install-prompt-actions {
    justify-content: space-between;
    gap: 8px;
  }
  
  .btn-dismiss,
  .btn-install {
    flex: 1;
    padding: 10px 16px;
    font-size: 13px;
  }
}
</style>
